import {
  CREATE_FUEL_LEVEL_READING_SUCCESS,
  FETCH_FUEL_LEVEL_READING_SUCCESS,
  GET_FUEL_LEVEL_READING_SUCCESS,
  SAVE_FUEL_LEVEL_READING_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_FUEL_LEVEL_READING_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_FUEL_LEVEL_READING_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_FUEL_LEVEL_READING_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_FUEL_LEVEL_READING_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    default:
      return state;
  }
}
